import { Model } from '@vuex-orm/core'

export default class Audit extends Model {
  // This is the name used as module name of the Vuex Store.
  static entity = 'audits'

  static primaryKey = '_id'

  // List of all fields (schema) of the post model. `this.attr` is used
  // for the generic field type. The argument is the default value.
  static fields () {
    return {
      _id: this.attr(null),
      entity: this.attr(null),
      method: this.attr(null),
      message: this.attr(null),
      entity_name: this.attr(null),
      author_user_id: this.attr(null),
      created_at: this.attr(null)
    }
  }
}



// WEBPACK FOOTER //
// ./src/models/Audit.js